// Story 084 — link-safety check for director-supplied URLs that we
// render as <a href={...}>. Mirrors the story 075 isSafeImageUrl
// posture: HTTPS in real environments, with a loopback http carve-out
// so local-dev fixtures can render. Real organizer URLs are always
// HTTPS; the carve-out only matters for tests / seed scripts running
// against http://127.0.0.1.

export function isSafeHttpsLink(url: string | null | undefined): url is string {
  if (!url) return false;
  try {
    const u = new URL(url);
    if (u.protocol === 'https:') return true;
    if (
      u.protocol === 'http:' &&
      (u.hostname === '127.0.0.1' || u.hostname === 'localhost')
    ) {
      return true;
    }
    return false;
  } catch {
    return false;
  }
}

/** Returns the URL's host for display when no label is provided. */
export function urlHost(url: string): string {
  try {
    return new URL(url).host;
  } catch {
    return url;
  }
}

/**
 * Story 084 — best-effort venue-name extraction from a director-pasted
 * maps URL. Returns null when nothing readable can be found, in which
 * case callers fall back to the tournament's own location text or the
 * URL host.
 *
 * Patterns covered:
 *  - Google Maps:      /maps/place/<Encoded+Name>/...
 *  - Google / Apple:   ?q=<Encoded Address>
 *  - Apple Maps:       ?address=<Encoded Address>
 */
export function mapPlaceName(url: string): string | null {
  try {
    const u = new URL(url);
    const placeMatch = u.pathname.match(/\/maps\/place\/([^/]+)/i);
    if (placeMatch && placeMatch[1]) {
      const decoded = decodeURIComponent(placeMatch[1]).replace(/\+/g, ' ').trim();
      if (decoded) return decoded;
    }
    const q = u.searchParams.get('q');
    if (q && q.trim()) return q.trim();
    const address = u.searchParams.get('address');
    if (address && address.trim()) return address.trim();
    return null;
  } catch {
    return null;
  }
}
